<template>
    <div>
      <div v-if="showNewProgramForm" class="modal-overlay">
        <div class="modal-content">
          <div class="d-flex flex-row justify-content-between align-items-center mb-3">
            <h2>{{ $t("new-program") }}</h2>
            <button type="button" class="close-btn" @click="closeForm">✖</button>
          </div>
          <div>
            <div v-if="validate && errors" class="alert alert-danger mb-3">{{ $t('required-fields-missing') }}</div>
            <div class="form-group">
              <label for="programName">{{ $t('name') }}</label>
              <input 
                v-model="program.name" 
                type="text" 
                id="programName" 
                class="form-control" 
                :class="{ 'is-invalid': validate && !program.name }" 
                placeholder="Enter program name" 
                required 
              />
            </div>
            <div class="form-group">
              <label for="publishedState">{{ $t('published-status') }}</label>
              <select 
                v-model="program.publishedState" 
                id="publishedState" 
                class="form-control"
              >
                <option :value="1">{{ $t('published') }}</option>
                <option :value="2">{{ $t('unpublished') }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="courseLength">{{ $t('course-length-years') }}</label>
              <input 
                v-model="program.courseLengthYears" 
                type="number" 
                id="courseLength" 
                class="form-control" 
                :class="{ 'is-invalid': validate && !program.courseLengthYears }" 
                placeholder="Enter course length in years" 
                min="1" 
                required 
              />
            </div>
            <div class="modal-actions">
              <button type="button" class="btn btn-secondary" @click="closeForm">{{ $t('cancel') }}</button>
              <button type="button" class="btn btn-primary" @click="createProgram">{{ $t('create') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import "@/styles/components/programmeCreate.scss"; 
  
  export default {
    props: {
      showNewProgramForm: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        program: {
          name: '',
          publishedState: 1, 
          courseLengthYears: '',
        },
        validate: false,
        errors: false,
      };
    },
    methods: {
      async createProgram() {
        this.validate = true;
        this.errors = false;
  
        if (!this.program.name || !this.program.courseLengthYears) {
          this.errors = true;
          return;
        }
  
        try {
          this.$store.commit('showBlockingSpinner');
  
          const res = await this.$cfetch(`${this.$settings.APIBaseURL}/programmes/create`, {
            method: 'POST',
            data: {
              Name: this.program.name,
              PublishedState: parseInt(this.program.publishedState),
              CourseLengthYears: parseInt(this.program.courseLengthYears),
            },
          });
  
          if (res.status === 'SUCCESS') {
            this.resetForm();
            this.$emit('programCreated'); 
            this.$emit('close');           
            
          } else {
            this.$store.commit("openDialog", {
              title: this.$t("something-went-wrong"),
              content: this.$t('program-create-failed'),
              confirmCallBack: function () {},
            });
          }
        } catch (err) {
          this.$log.error.call(this, err);
        } finally {
          this.$store.commit('hideBlockingSpinner');
        }
      },
      closeForm() {
        this.resetForm();
        this.$emit('close');
      },
      resetForm() {
        this.program = { name: '', publishedState: 1, courseLengthYears: '' };
        this.validate = false;
        this.errors = false;
      },
    },
  };
  </script>
  